import * as React from "react";
import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";

const Textarea = React.forwardRef(({ className, label, ...props }, ref) => (
  <div className="flex flex-col gap-y-1 items-start w-full">
    {label && <Label htmlFor={props.name}>{label}</Label>}
    <textarea
      className={cn(
        "flex min-h-[128px] w-full rounded-2xl border border-neutral-200 bg-white px-6 py-3 text-lg ring-offset-white placeholder:text-neutral-50 disabled:cursor-not-allowed disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2",
        className
      )}
      ref={ref}
      {...props}
    />
  </div>
));

Textarea.displayName = "Textarea";

export { Textarea };
